import axios from "axios";
import { MessageBox, Message } from "element-ui";
import { getToken } from "./auth";
import { Loading } from "element-ui";

// 请求计数器
let activeRequests = 0;
let loadingInstance = null;

// 管理loading状态
const loading = {
    // 显示全局loading
    show() {
        if (!loadingInstance) {
            loadingInstance = Loading.service({
                fullscreen: true,
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }
    },

    // 隐藏loading
    hide() {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
    },

    // 开始新请求
    start() {
        if (activeRequests === 0) {
            this.show();
        }
        activeRequests++;
    },

    // 结束请求
    end() {
        activeRequests--;
        if (activeRequests === 0) {
            this.hide();
        }
    }
};

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // 跨域请求时发送Cookie
    timeout: 60 * 100000 // 请求超时
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        if (config.contentType) {
            config.headers["Content-Type"] = config.contentType;
        }
        // 显示loading，除非明确跳过
        if (config.skipLoading !== true) {
            loading.start();
        }
        config.headers["userId"] = getToken();
        const authHeader = sessionStorage.getItem("Authorization");
        //debugger;
        if (authHeader) {
            config.headers["authorization"] = authHeader;
        }
        return config;
    },
    (error) => {
        loading.end();
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // 请求完成，减少计数
        if (response.config.skipLoading !== true) {
            loading.end();
        }
        const res = response.data;
        if (Number(res.code) === 502) {
            MessageBox.alert(res.msg || "请求失败", "系统提示", {
                confirmButtonText: "确定",
                type: "warning"
            }).then(() => {
                try {
                    sessionStorage.clear();
                } catch (e) {
                    // ignore
                }
                window.location.replace("/zdsysSbdwClient/");
            });
            return Promise.reject(res);
        }
        // 后端业务状态为 401，统一清理会话并跳转登录
        if (Number(res.code) === 401) {
            try {
                sessionStorage.clear();
            } catch (e) {
                // ignore
            }
            // 使用项目的 history base，直接整页跳转到登录页
            window.location.replace("/zdsysSbdwClient/");
            return Promise.reject(res);
        }
        // 文件流/二进制下载场景：不按 {code:200} 结构解析
        const rt = response.config && response.config.responseType;
        if (rt === "blob" || rt === "arraybuffer") {
            return response.data;
        }
        // 有些浏览器/axios版本 responseType 未显式写入 config，这里兜底判断
        if (response.data instanceof Blob) {
            return response.data;
        }

        if (Number(res.code) === 200) {
            return res;
        }
        return Promise.reject(res);
    },
    (error) => {
        // 请求失败，减少计数
        if (error.config && error.config.skipLoading !== true) {
            loading.end();
        }
        // HTTP 状态为 401，统一清理会话并跳转登录
        const status = error.response && error.response.status;
        if (status === 401) {
            try {
                sessionStorage.clear();
            } catch (e) {
                // ignore
            }
            window.location.replace("/zdsysSbdwClient/");
        }
        return Promise.reject(error);
    }
);

export default service;
